window.addEventListener('load', function () {
    $(document).on('click', '.item-header', function (e) {
        const $item = $(this).closest('.faq-list__item');
        if ($item.length) {
            $item.siblings().removeClass('is-active').find('.item-answer').slideUp(200);
            $item.toggleClass('is-active');
            $item.find('.item-answer').slideToggle(200);
        }
    });

    function loadFAQ(handle, $item, page = 1) {
        let sectionId = $('.faq-section').data('section-id');
        let productHandle = $('.faq-section').data('product-handle');
        const $container = $('.faq-content');

        if ($item) {
            $item.addClass('is-active').siblings().removeClass('is-active');
        }

        // 模拟加载
        $container.css('opacity', '0.5');

        const query = `${handle}|${page}|${productHandle}`;

        // 通过搜索接口分页
        $.ajax({
            url: '/search',
            data: {
                section_id: sectionId,
                q: query,
            },
            dataType: 'html',
            success: function (responseText) {
                const $newContent = $(responseText).find('.faq-content').html();
                $container.html($newContent).css('opacity', '1');

                initPagination();
            },
            error: function (error) {
                console.error('Error fetching FAQs:', error);
                $container.css('opacity', '1');
            },
        });
    }

    $(document)
        .off('click', '.pagination-item')
        .on('click', '.pagination-item', function () {
            const page = $(this).data('page');
            if (page) {
                const $activeItem = $('.scroll-nav__item.is-active');
                let handle = $activeItem.length ? $activeItem.data('handle') : '';
                loadFAQ(handle, null, page);
                // 滚动到 FAQ 区域顶部
                scrollToTop();
            }
        });

    $('.scroll-nav__item').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('is-active')) return;
        let handle = $(this).data('handle');
        loadFAQ(handle, $(this));
        scrollToTop();
    });

    function scrollToTop() {
        $('html, body').animate(
            {
                scrollTop: $('#section-faq').offset().top - 150,
            },
            500
        );
    }

    function initPagination() {
        let show_pagination = $('.faq-container').data('show-pagination');
        if (show_pagination) {
            const $metaData = $('#faq-meta-data');
            const $container = $('.faq-content');

            if (!$container.length || !$metaData.length) return;

            const totalCount = parseInt($metaData.data('total-count'), 10);
            const currentPage = parseInt($metaData.data('current-page'), 10);
            const itemsPerPage = parseInt($metaData.data('items-per-page'), 10);
            const $paginationContainer = $container.find('.faq-pagination-container');

            if (totalCount <= itemsPerPage) {
                $paginationContainer.empty();
                return;
            }

            const totalPages = Math.ceil(totalCount / itemsPerPage);

            function renderControls() {
                let html = '<nav class="pagination fs-14 mt-50"><ul class="pagination-list">';

                // Prev
                const prevDisabled = currentPage === 1 ? ' style="pointer-events: none; opacity: 0.5;"' : '';
                const prevPage = currentPage - 1;
                html += `<li class="pagination-item pagination-item__prev" data-page="${prevPage}"${prevDisabled}>
                    <a href="javascript:;" class="pagination-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none">
                        <path d="M8.46973 0.732788L1.46973 7.23279L8.46973 13.7328" stroke="black" stroke-width="2"/>
                        </svg>
                    </a>
                    </li>`;

                // Pages
                for (let i = 1; i <= totalPages; i++) {
                    if (totalPages > 7) {
                        if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
                            html += `<li class="pagination-item ${i === currentPage ? 'on' : ''}" data-page="${i}">
                                    <a href="javascript:;" class="pagination-link"><span>${i}</span></a>
                                </li>`;
                        } else if (i === currentPage - 2 || i === currentPage + 2) {
                            html += `<li class="pagination-item"><a href="javascript:;" class="pagination-link"><span>...</span></a></li>`;
                        }
                    } else {
                        html += `<li class="pagination-item ${i === currentPage ? 'on' : ''}" data-page="${i}">
                                <a href="javascript:;" class="pagination-link"><span>${i}</span></a>
                            </li>`;
                    }
                }

                // Next
                const nextDisabled = currentPage === totalPages ? ' style="pointer-events: none; opacity: 0.5;"' : '';
                const nextPage = currentPage + 1;
                html += `<li class="pagination-item pagination-item__next" data-page="${nextPage}"${nextDisabled}>
                        <a href="javascript:;" class="pagination-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none">
                            <path d="M0.680664 0.732788L7.68066 7.23279L0.680664 13.7328" stroke="black" stroke-width="2"/>
                            </svg>
                        </a>
                        </li>`;

                html += '</ul></nav>';
                $paginationContainer.html(html);
            }

            renderControls();
        }
    }

    initPagination();
});